import React from 'react';
import * as style from './style.module.scss';
import { Forest } from '../Trees';

interface FooterProps {
  songTitle: string;
}

const Footer = ({ songTitle }: FooterProps) => {
  const copyNotice = (
    <>
      {process.env.GATSBY_SITE_LANG === 'en' ? 'The song' : 'Låten'}{' '}
      <strong>{songTitle}</strong> © 2021 Anna Vild & Andreas
      Magnusson
    </>
  );

  return (
    <footer className={style.footer}>
      <Forest />
      <div className={style.footer__content}>
        <span className={style.footer__copy}>{copyNotice}</span>
        <span className={style.footer__credit}>
          {process.env.GATSBY_SITE_LANG === 'en'
            ? 'website by'
            : 'hemsida av'}{' '}
          <a
            href="https://twentyonepenguins.xyz"
            target="blank"
            rel="noopener"
          >
            twentyonepenguins
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
